var _       = require('underscore');
var $       = require('jquery');
var Core    = require('../core/core.js');
var _       = require('underscore');
/**
 * Creates an overlay tray large component item
 *
 * @class
 */

class TrayTabLargeComponentsItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'overlay': false,
                'defaults': {
                    'name': '',
                    'description': '',
                    'thumb_url': ''
                },
                'overlay_properties': {}
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="grid__item one-fifth mobile--one-third desktop--huge--one-sixth editor__tray__largecomponents__item">
                <a class='editor__tray__largecomponents__item__link js-editor__tray__largecomponents__item__link'>
                    <div class="editor__tray__largecomponents__item__inner">
                        <div class="editor__tray__largecomponents__item__inner__img">
                            <div class='editor__tray__largecomponents__item__inner__img__loading'>
                                <img src="https://123d-circuits-assets.s3.amazonaws.com/thumbloading.png">
                                <div class="throbber">
                                    <div class="throbber__bounce1"></div>
                                    <div class="throbber__bounce2"></div>
                                    <div class="throbber__bounce3"></div>
                                </div>
                            </div>
                            <img class="editor__tray__largecomponents__item__inner__img__preview" src="<%= external_url(defaults['thumb_url']) %>" onload="$(this).prev().addClass('invisible');$(this).show();" onerror='$(this).attr("src", "https://123d-circuits-assets.s3.amazonaws.com/thumbnotfound.png");' style='display:none'>

                            <div class="editor__tray__largecomponents__item__inner__img__info">
                            <% _.each(overlay_properties, function(value, key){ %>
                                 <div class="editor__tray__largecomponents__item__inner__img__info__property">
                                    <div class="editor__tray__largecomponents__item__inner__img__info__property__name"> <%- key %></div>
                                    <div class="editor__tray__largecomponents__item__inner__img__info__property__value"> <%- value %></div>
                                </div>
                            <% }); %>
                            </div>
                        </div>
                        <div class="editor__tray__largecomponents__item__inner__block">
                            <div class="editor__tray__largecomponents__item__inner__block__title">
                                <%- defaults.name %>
                            </div>

                            <% if(overlay) { %>
                                <div class="mouse--action editor__tray__largecomponents__item__inner__block__info" 
                                onmouseenter="$(this).parents('.editor__tray__largecomponents__item__inner').find('.editor__tray__largecomponents__item__inner__img__info').show()" 
                                onmouseleave="$(this).parents('.editor__tray__largecomponents__item__inner').find('.editor__tray__largecomponents__item__inner__img__info').hide()">
                                <%= embedded_svg("icon-info.svg") %>
                                </div>
                            <% } %>
                        </div>
                    </div>
                </a>
            </div>
        `;

        super.render();

        /**
         * Click item
         *
         * @fires TrayTabLargeComponentsItem#_itemClicked
         */
        
        $('.js-editor__tray__largecomponents__item__link', this.$el).on('click', this._itemClicked);

    }

    /**
     * @event TrayTabLargeComponentsItem#Cioui:TrayTabItem:clicked
     * @property {String}Cioui:TrayTabItem:clicked
     * @returns {Object} e - click event
     */

    _itemClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:clicked', e);
    }

}
module.exports = TrayTabLargeComponentsItem;
